import script from "./SupportStatusScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportStatusScreen.vue?vue&type=script&setup=true&lang=js"

import "./SupportStatusScreen.vue?vue&type=style&index=0&id=e31b0efc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e31b0efc"]])

export default __exports__